import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SwitchToggle from "../../components/SwitchToggle";
import DragHandleIcon from "@mui/icons-material/DragHandle";

const PromotionList = () => {
  const navigate = useNavigate();

  const promotions = [
    {
      id: 1,
      title: "Summer Sale",
      banner: "/static/images/placeholder.png",
      description: "Follow Us & Enjoy 15% OFF!",
      type: "App only",
      visible: true,
      startTime: "2025-06-01",
      endTime: "2025-06-30",
    },
    {
      id: 2,
      title: "Exclusive Store Deal",
      banner: "/static/images/placeholder.png",
      description: "Buy 1 Get 1 Free on select items",
      type: "In-store",
      visible: false,
      startTime: "2025-07-01",
      endTime: "2025-07-15",
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Sort</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Schedule</TableCell>
            <TableCell>Visibility</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {promotions.map((promo) => (
            <TableRow hover key={promo.id}>
              <TableCell>
                <DragHandleIcon className="drag_handle" />
              </TableCell>
              <TableCell>
                <Box component="a" className="user_block click_action" onClick={()=> navigate('/manage-promotions/view')}>
                  <figure className="no_radius">
                    <img src={promo.banner} alt={promo.title} />
                  </figure>
                  <p>
                    <b>{promo.title}</b>
                  </p>
                </Box>
              </TableCell>
              <TableCell>{promo.description}</TableCell>
              <TableCell>{promo.type}</TableCell>
              <TableCell>{promo.startTime} to {promo.endTime}</TableCell>
              <TableCell><SwitchToggle defaultChecked={promo.visible} /></TableCell>
              <TableCell>
                <div className="table_actions v2">
                  <IconButton onClick={() => navigate("/manage-promotions/view")}>
                    <img src="/static/images/eye_icon.svg" alt="View" />
                  </IconButton>
                  <IconButton onClick={() => navigate("/manage-promotions/edit")}>
                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                  </IconButton>
                  <IconButton>
                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PromotionList;
